module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/13mill-active-d14259bb1febd35729964b903d8c9ab4.png";